/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect, useState } from 'react';

import { DebugScreenController } from '../../core/debugscreen';
import { DeviceModel } from '../../core/device';
import { SystemMemory } from './Types';

import './SystemInfo.scss';

const SystemInfo: FunctionComponent = (): JSX.Element => {
    const systemInfoHeaderText = 'System Information';
    const ONE_MEGABYTES_IN_BYTES = 1000 * 1000;
    const HUNRED_PERCENT = 100;

    const initialState: SystemMemory = {
        jsHeapSizeLimit: 0,
        totalJSHeapSize: 0,
        usedJSHeapSize: 0,
        availableMemory: 0,
        totalMemory: 0,
        memoryStatus: '',
        cpuLoad: 0,
    };

    const [memoryInfo, setMemoryInfo] = useState(initialState);

    const handleMemory = (data) => {
        setMemoryInfo((state) => {
            return {
                ...state,
                ...data,
            };
        });
    };

    useEffect(() => {
        DebugScreenController.getInstance().getSystemMemoryEventListener().subscribe(handleMemory);
        return () => {
            DebugScreenController.getInstance().getSystemMemoryEventListener().cancel(handleMemory);
        };
    }, []);

    return (
        <div className="system-info-container">
            <div className="system-info-heading">{systemInfoHeaderText}</div>
            <div className="system-info">
                <div className="section-title">Browser (JS Heap) Memory</div>
                <p className="section-content">
                    Used: {(memoryInfo.usedJSHeapSize / ONE_MEGABYTES_IN_BYTES).toFixed(2)}mb (
                    {(memoryInfo.totalJSHeapSize / ONE_MEGABYTES_IN_BYTES).toFixed(2)}mb)
                </p>
                <p className="section-content">
                    Total: {(memoryInfo.jsHeapSizeLimit / ONE_MEGABYTES_IN_BYTES).toFixed(2)}mb
                </p>
                {DeviceModel.isTizenPlatform() ? (
                    <>
                        <div className="section-title">System Information</div>
                        <p className="section-content">
                            Available Memory:{' '}
                            {((memoryInfo.availableMemory ?? 0) / ONE_MEGABYTES_IN_BYTES).toFixed(
                                2,
                            )}
                            mb
                        </p>
                        <p className="section-content">
                            Total Memory:
                            {((memoryInfo.totalMemory ?? 0) / ONE_MEGABYTES_IN_BYTES).toFixed(2)}mb
                        </p>
                        <p className="section-content">Memory Status: {memoryInfo.memoryStatus}</p>
                        <p className="section-content">
                            CPU Load: {((memoryInfo.cpuLoad ?? 0) * HUNRED_PERCENT).toFixed(2)}%
                        </p>
                    </>
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
};

export default SystemInfo;
